module.exports = __webpack_public_path__ + "img/full0-min.82414c49.png";